export const COLORS = [
  '--color-action-link',
  '--color-encore-lime',
  '--color-encore-yellow',
  '--color-encore-orange',
];
export const OTHER_COLOR = '--color-main-border';
export const MAX_PERCENTAGE = 100;
export const INITIAL_OFFSET = 25;
